import { render, staticRenderFns } from "./category_twins_right.vue?vue&type=template&id=1c4a0ff7&scoped=true&"
import script from "./category_twins_right.vue?vue&type=script&lang=js&"
export * from "./category_twins_right.vue?vue&type=script&lang=js&"
import style0 from "./category_twins_right.vue?vue&type=style&index=0&id=1c4a0ff7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4a0ff7",
  null
  
)

component.options.__file = "category_twins_right.vue"
export default component.exports